import { setContext } from '@apollo/client/link/context'

import { schemaVersion } from '@/gql/reviews'
import { useLocaleStore } from '@/stores'

const localeLink = setContext((_, { headers }) => {
  const localeStore = useLocaleStore()
  const requestLocale = localeStore.locale

  return {
    headers: {
      ...headers,
      'request-locale': requestLocale,
      locale: requestLocale,
      'omr-service-name': 'eventmanager',
      'x-api-version': schemaVersion,
    },
  }
})

export default localeLink
